export default __webpack_public_path__ + "static/media/japango-screenshot-02.583de757.png";